module.exports = __webpack_public_path__ + "static/media/gulp2.76a9d4d9.mp3";